export default __webpack_public_path__ + "static/media/diploma-bazi_2024.4f29e557.jpeg";